import { Bool } from './Bool'
import { Date } from './Date'
import { DateTime } from './DateTime'
import { Enum } from './Enum'
import { HexColour } from './HexColour'
import { Money } from './Money'
import { Registration } from './Registration'
import { SliceOfEnum } from './SliceOfEnum'

export enum ExactMatchKey {
  Bool = 'bool',
  Date = 'Date',
  DateTime = 'DateTime',
  HexColour = 'HexColour',
  Money = 'Money',
  Registration = 'Registration'
}

export enum PartialMatchKey {
  Enum = '^Enum.*',
  SliceOfEnum = '^SliceOfEnum.*'
}

export const structTypeToComponentMap = {
  [ExactMatchKey.Bool]: Bool,
  [ExactMatchKey.HexColour]: HexColour,
  [ExactMatchKey.Date]: Date,
  [ExactMatchKey.DateTime]: DateTime,
  [ExactMatchKey.Money]: Money,
  [ExactMatchKey.Registration]: Registration,
  [PartialMatchKey.Enum]: Enum,
  [PartialMatchKey.SliceOfEnum]: SliceOfEnum
}
